<template>
  <div>
    <staff-login-dialog
      ref="staffLoginDialog" />
    <el-container>
      <el-header class="header" :style="headerStyle">
        <div class="container">
          <router-link :to="{name: 'Index'}" tag="h1">cip</router-link>
          <div class="staff-loggedin-nav" v-show="isStaffLoggedIn">(店長ログイン中)</div>
          <slot name="header"></slot>
          <ul class="nav">
            <li class="nav-item">
              <el-dropdown @command="handleCommand">
                <span><i class="el-icon-more"></i></span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item v-show="!isStaffLoggedIn" command="staffLogin">スタッフログイン</el-dropdown-item>
                  <el-dropdown-item command="logout">ログアウト</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </li>
          </ul>
        </div>
      </el-header>
      <el-main>
        <slot></slot>
      </el-main>
    </el-container>
  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import StaffLoginDialog from '@/components/Account/StaffLoginDialog'

export default {
  name: 'MainFrame',
  components: {
    StaffLoginDialog,
  },
  computed: {
    ...mapGetters(['isStaffLoggedIn']),
    headerStyle () {
      return {
        'background-color': this.isStaffLoggedIn ? '#2efe64' : '#c0c0c0',
      }
    },
  },
  methods: {
    ...mapActions(['logout']),
    handleCommand (command) {
      switch (command) {
        case 'staffLogin':
          this.$refs.staffLoginDialog.show()
          break
        case 'logout':
          this.doLogout()
          break
        default:
          break
      }
    },
    doLogout () {
      this.logout()
      this.$router.push({name: 'Login'})
    },
  },
}
</script>

<style scoped>
.el-header {
  padding: 0;
  margin: 0;
  display: block;
}

.container {
  box-sizing: border-box;
  display: block;
  width: 100%;
  height: 100%;
}

.container .staff-loggedin-nav {
  float: left;
  line-height: 60px;
  margin-left: 20px;
}

.nav-item {
  float: right;
}

.header {
  top: 0;
  left: 0;
  position: relative;
}

.header h1 {
  float: left;
  margin: 0;
  padding-left: 20px;
  font-size: 32px;
  font-weight: 400;
  line-height: 60px;
  -webkit-margin-start: 0px;
}

.header .nav {
  float: right;
  height: 100%;
  line-height: 60px;
  background: transparent;
  padding: 0;
  margin: 0;
  padding-right: 20px;
}

.header .nav-item {
  margin: 0;
  float: left;
  list-style: none;
  position: relative;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/Layout/Frame.vue